import { render, staticRenderFns } from "./CardWishlist.vue?vue&type=template&id=d9de057a&"
import script from "./CardWishlist.vue?vue&type=script&lang=js&"
export * from "./CardWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports